(function () {
  'use strict';

  angular.module('app.admin')
    .factory('adminService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
            return data;
        }

        function getMessage(data) {
            if (data) {
                return data.message;
            }
            return false;
        }

        function handleRequest(url, method, params, loader) {
            var deferred = $q.defer();

            var req = {
                url: url,
                method: method,
                data: JSON.stringify(params),
                loader: loader
            } 

            $http(req)
                .success(function (data) {
                var dataRes = angular.fromJson(data);

                if (checkResponse(dataRes)) {
                    deferred.resolve(dataRes);
                } else {
                    deferred.reject(getMessage(dataRes));
                }
            })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function getPlatformIcon (platform_id){
            if (platform_id == 1) 
                return "/images/ico/Blogger Logo.png";
            else if (platform_id == 2)
                return "/images/ico/Instagram Logo1.png";
            else if (platform_id == 3)
                return "/images/ico/Pinterest Logo.png";
            else if (platform_id == 4)
                return "/images/ico/snapchat.png";
            else if (platform_id == 5)
                return "/images/ico/Twitter Logo.png";
            else if (platform_id == 6)
                return "/images/ico/YouTube Logo.png";
            else if (platform_id == 7)
                return "/images/ico/Facebook Logo.png";
            else if (platform_id == 8)
                return "/images/ico/Tiktok_logo.png";
            else
                return "";
        };

        function getCountryFlag(country_code) {
            return "/images/country-flag/named-by-code/" + country_code + ".png";
        }

        function getApproveIcon (status) {
            if (status == 2) {
                return "/images/ico/Checkmark 2.png";
            } else {
                return "/images/ico/Minus 2.png";
            }
        }

        function getActiveIcon (isActive) {
            if (isActive == 1) {
                return "/images/ico/Checkmark 2.png";
            } else {
                return "/images/ico/Minus 2.png";
            }
        }

        function getUserStatusIcon (user_status_id) {
            if(user_status_id == 1) {
                return "/images/ico/Checkmark 2.png";
            } else if (user_status_id == 2) {
                return "/images/ico/Blocked icon.png";
            } else {
                return "/images/ico/Minus 2.png";
            }
        }

        function pagination (number, pageSize) {
            if((number % pageSize) != 0){
                var remainNo = number - (number % pageSize);
                return remainNo/pageSize + 1;
            } else{
                return number/pageSize;
            }
        }

        function getCountryExceptInfluencerManagement(loader) {
            var url_getCountryExceptInfluencerManagement = $rootScope.apiUrl + 'admin/getCountryExceptInfluencerManagement';
            return handleRequest(url_getCountryExceptInfluencerManagement, 'GET', null, loader);
        }

        function getAllCountry(loader) {
            var url_getAllCountry = $rootScope.apiUrl + 'admin/getAllCountry';
            return handleRequest(url_getAllCountry, 'GET', null, loader);
        }

        function updateInfluencer(blog_id, params, loader) {
            var url_updateInfluencer = $rootScope.apiUrl + 'admin/updateInfluencer/' + blog_id;
            return handleRequest(url_updateInfluencer, 'POST', params, loader);
        }

        function updateNPrevious(blog_id, params, loader) {
            var url_updateNPrevious = $rootScope.apiUrl + 'admin/updateNPrevious/' + blog_id;
            return handleRequest(url_updateNPrevious, 'POST', params, loader);
        }

        function updateNNext(blog_id, params, loader) {
            var url_updateNNext = $rootScope.apiUrl + 'admin/updateNNext/' + blog_id;
            return handleRequest(url_updateNNext, 'POST', params, loader);
        }

        function setInactiveInfluencer(params, loader) {
            var url_setInactiveInfluencer = $rootScope.apiUrl + 'admin/setInactiveInfluencer';
            return handleRequest(url_setInactiveInfluencer, 'POST', params, loader);
        }

        function setActiveInfluencer(params, loader) {
            var url_setActiveInfluencer = $rootScope.apiUrl + 'admin/setActiveInfluencer';
            return handleRequest(url_setActiveInfluencer, 'POST', params, loader);
        }

        var getCountryLanguage = function(id, loader) {
            var url = $rootScope.apiUrl + 'admin/getCountryLanguage?country_id=' + id;
            return handleRequest(url, 'GET', null, loader);
        };

        service.getPlatformIcon = getPlatformIcon;
        service.getApproveIcon = getApproveIcon;
        service.getActiveIcon = getActiveIcon;
        service.getUserStatusIcon = getUserStatusIcon;
        service.pagination = pagination;
        service.getCountryExceptInfluencerManagement = getCountryExceptInfluencerManagement;
        service.getAllCountry = getAllCountry;
        service.updateInfluencer = updateInfluencer;
        service.updateNPrevious = updateNPrevious;
        service.updateNNext = updateNNext;
        service.setInactiveInfluencer = setInactiveInfluencer;
        service.setActiveInfluencer = setActiveInfluencer;
        service.getCountryLanguage = getCountryLanguage;
        service.getCountryFlag = getCountryFlag;

        return service;
    }]);

})();
